export default __webpack_public_path__ + "static/fendingOff-fa7e7d8a519dbdf958379eafbc3bd167.svg";